import { gql } from "apollo-boost"

export const CREATE_SUSTAINABILITY_DETAILS = gql`
  mutation createSustanabilityDetails($data: CreateSustainabilityDetails!) {
    CreateSustainabilityDetails(data: $data)
  }
`